module.exports = __webpack_public_path__ + "img/TXT.404de2ae.png";